'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    listClassNames: function() {
        return listClassNames;
    },
    useListStyles_unstable: function() {
        return useListStyles_unstable;
    }
});
const _react = require("@griffel/react");
const listClassNames = {
    root: 'fui-List'
};
const useRootBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r1m6yby2", null, [
    ".r1m6yby2{padding:0;margin:0;text-indent:0;list-style-type:none;}"
]);
const useListStyles_unstable = (state)=>{
    'use no memo';
    const rootStyles = useRootBaseStyles();
    state.root.className = (0, _react.mergeClasses)(listClassNames.root, rootStyles, state.root.className);
    return state;
};
